import React from 'react';
import { Button } from 'system/atoms';
import { useModalV2 } from 'common/modal/hooks/useModalV2';

type Props = {
  onClearQuestions: () => void;
};

export const CampaignCreationClearQuestionsButton: React.FC<Props> = ({
  onClearQuestions
}) => {
  const { openModal } = useModalV2();

  const handleClearQuestions = () => {
    openModal({
      title: 'Clear questions?',
      subtitle:
        'All questions, preferred answers and document requests will be deleted immediately. This cannot be undone.',
      primaryButtonText: 'Cancel',
      secondaryButtonText: 'Delete',
      primaryButtonProps: { variant: 'primary' },
      secondaryButtonProps: { variant: 'tertiary', state: 'destructive' },
      onSecondaryAction: onClearQuestions // Delete action
    });
  };

  return (
    <Button
      variant="tertiary"
      state="destructive"
      onClick={handleClearQuestions}
    >
      Clear questions
    </Button>
  );
};
